/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1SettingsEducationQueryResponse } from '../../types/GetV1SettingsEducation.ts'

export const getV1SettingsEducationQueryKey = () => [{ url: '/v1/settings/education' }] as const

export type GetV1SettingsEducationQueryKey = ReturnType<typeof getV1SettingsEducationQueryKey>

/**
 * {@link /v1/settings/education}
 */
export async function getV1SettingsEducation(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1SettingsEducationQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/settings/education`, ...requestConfig })
    return res
}

export function getV1SettingsEducationQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1SettingsEducationQueryKey()
    return queryOptions<
        ResponseConfig<GetV1SettingsEducationQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1SettingsEducationQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1SettingsEducation(config)
        },
    })
}

/**
 * {@link /v1/settings/education}
 */
export function useGetV1SettingsEducation<
    TData = ResponseConfig<GetV1SettingsEducationQueryResponse>,
    TQueryData = ResponseConfig<GetV1SettingsEducationQueryResponse>,
    TQueryKey extends QueryKey = GetV1SettingsEducationQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1SettingsEducationQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1SettingsEducationQueryKey()

    const query = useQuery(
        {
            ...getV1SettingsEducationQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
